import { IUrlRouterProvider } from 'angular-ui-router';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
    // Every fanreel report leads to fanreel metrics
  urlRouterProvider.when('/reporting/{reportId}/fanreel', '/insights/galleries');
  urlRouterProvider.when('/reporting/{reportId}/fanreel/{reelId}', '/insights/galleries');

    // Every like2buy report leads to like2buy metrics
  urlRouterProvider.when('/reporting/{reportId}/like2buy', '/insights/like2buy');
  urlRouterProvider.when('/reporting/{reportId}/like2buy/reporting', '/insights/like2buy');

    // Every reveal report leads to reveal metrics
  urlRouterProvider.when('/reporting/{reportId}/reveal', '/insights/reveal');

    // Every showroom report leads to showroom
  urlRouterProvider.when('/reporting/{reportId}/insights/showroom', '/insights/showroom');

    // Every instagram report previously lead to homepage or 404, now it's instagram
  urlRouterProvider.when('/reporting/{reportId}/instagram', '/instagram');
  urlRouterProvider.when('/reporting/{reportId}/instagram/brand', '/instagram');
  urlRouterProvider.when('/reporting/{reportId}/instagram/hashtags', '/instagram');

    // Every pinterest report previously lead to a 404, now it's pinterest
  urlRouterProvider.when('/reporting/{reportId}/pinterest', '/pinterest');
  urlRouterProvider.when('/reporting/{reportId}/pinterest/brand', '/pinterest');
  urlRouterProvider.when('/reporting/{reportId}/pinterest/organic', '/pinterest');

    // Every other report leads to homepage
  urlRouterProvider.when('/reporting/{reportId}/{channel}', '/');
  urlRouterProvider.when('/reporting/{reportId}/{channel}/{section}', '/');
}

export const states = {
  // no-op
};
